import { observer } from 'mobx-react';
import { CalculatedColumn } from '@bst/react-data-grid';

import { UserExistingRolesResponseDTO } from '../../../apiclients/bstinsights';
import { useCellRoleFilter } from '../Hooks/useCellRoleFilter';
import { CellFilter } from '../../CellFilter/Views/CellFilter';
import { CellFilterValueList } from '../../CellFilter/Views/CellFilterValueList';

/**
 * @property column - CalculatedColumn; Individual column from DataGrid columns
 * @property columnKey - string; Column key to map data key
 */
type Props<Row, SummaryRow> = {
  column: CalculatedColumn<Row, SummaryRow>;
  columnKey: string;
  existingRolesCount?: UserExistingRolesResponseDTO
};

/**
 * Role Filter component
 */
export const CellRoleFilter = observer(<Row, SummaryRow = unknown>(props: Props<Row, SummaryRow>) => {
  const {
    isActive,
    filterItems,
    handleCheckboxChange
  } = useCellRoleFilter(props)

  return (
    <CellFilter hasNotification={isActive}>
      <CellFilterValueList
        height="auto"
        data={filterItems}
        isLoading={false}
        onCheckedChange={(_, item) => handleCheckboxChange(item)}
      />
    </CellFilter>
  );
})